<template>
    <div class="uqbar-logo" :style="mobileStyle">
        <a href="https://spaces.airberlinalexanderplatz.de/project-space" target="_blank">
            <img src="/uqbar-logo.png" alt="UQ-BAR-A-BA" class="uqbar-image" />
        </a>
    </div>
</template>

<script>
export default {
  name: 'UqBarBanner',
  data () {
    return {
      mobileStyle: {}
    }
  },
  mounted () {
    // Set mobile styles immediately to prevent flash
    if (window.innerWidth <= 480) {
      this.mobileStyle = {
        height: '60px',
        minHeight: '60px',
        maxHeight: '60px',
        padding: '0.25rem',
        transition: 'none'
      }
      // Also set directly on the element for immediate effect
      if (this.$el) {
        this.$el.style.height = '60px'
        this.$el.style.minHeight = '60px'
        this.$el.style.maxHeight = '60px'
        this.$el.style.padding = '0.25rem'
        this.$el.style.transition = 'none'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/vars";
@import "../../styles/mixins";

.uqbar-logo {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 60px;
    min-height: 60px;
    width: auto;
    background-color: #ffffff;
    padding: 0.25rem;
    transition: none;

    @include wider-then-phone {
      height: 100%;
      min-height: auto;
    padding: 0.5rem;
      transition: filter 0.2s ease-in-out;
    }

    .uqbar-image {
        max-height: 60px;
        width: auto;
        object-fit: contain;
        transition: none;

        @media (max-width: 30rem) {
          max-height: none !important;
          height: 100% !important;
          width: auto !important;
        }

        @include wider-then-phone {
        transition: all 0.2s ease-in-out;
        }

        &:hover {
            transform: scale(1.05);
            filter: brightness(1.1);
        }
    }

    a {
        text-decoration: none;
        display: block;
        transition: all 0.2s ease-in-out;

        &:hover {
            .uqbar-image {
                filter: brightness(1.2);
                transform: scale(1.05);
            }
        }
    }
}
</style>
